export default {
    babyDriver: (state) => {
        return state.babyDriver;
    },
};